import Page from './content.page.vue'

let routes = [
  {
    path: 'content',
    name: 'content',
    component: Page
  }
]

export default routes
